<div class="status-area">
    <div [ngClass]="getClass(statusId)" class="status-base">{{ getStatus(statusId) }}</div>
</div>